
// Version configuration for deployment tracking
export const APP_VERSION = "1.0.0";
export const BUILD_DATE = new Date().toISOString();
